import React, { useEffect, useRef, useState } from 'react';
import Slider from "react-slick";
import styles from './FeedPreview.module.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { isBrowser, isIOS, isMobile } from 'react-device-detect';
import api from '../../../api';

const FeedPreview = ({ setAdViseStep, stepProps, setStepProps, marginTop, setIsPreviewMode }) => {
  const sliderRef = useRef(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [fileInfoList, setFileInfoList] = useState([]);
  const [isDuplicate, setIsDuplicate] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const files = stepProps[8]?.result || [];

  const settings = {
    infinite: false,
    speed: 200,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    touchThreshold: 100,
    beforeChange: (_, newIndex) => setCurrentSlide(newIndex),
  };

  const whenHomeButtonClicked = () => {
    const confirmHome = window.confirm(
      "첫 화면으로 돌아가면 편집 결과가 사라집니다.\n\n정말 돌아가시겠습니까?"
    );
    if (confirmHome) {
      setAdViseStep(0);
    }
  };

  const whenNameChanged = (value) => {
    setStepProps(prev => {
      const newProps = [...prev];
      newProps[8] = {...newProps[8], fileName: value}
      return newProps;
    })
  }

  const saveFiles = async () => {
    if(stepProps[8].fileName.length==0)
      return;
    
    setIsSaving(true);
    const infoRes = await api.get('/advise/admin/fileInfo', {
      params: { name: stepProps[8].fileName }
    });
    const matches = infoRes.data || [];
    const exact = matches.find(item => item.name === stepProps[8].fileName);

    if (exact) {
      // 이미 업로드 완료된 경우
      if (exact.is_uploaded) {
        window.alert(`이미 ${exact.region} 계정에 업로드된 프로젝트입니다.\n다른 파일명을 입력해주세요.`);
        setIsSaving(false);
        return;
      }
      // 존재만 하고 업로드되지 않았다면 덮어쓰기 확인
      const ok = window.confirm("이미 존재하는 파일명입니다.\n기존 파일을 덮어쓰시겠습니까?");
      if (!ok) {
        setIsSaving(false);
        return;
      }
    }

    const selectedCursors = new Set(
      (stepProps[6].selectedImages || []).map(([blogCursor, _]) => blogCursor)
    );

    // 2) 그 cursor 들에 해당하는 blogReviews 만 필터링해서 매핑
    const allAuthorInfoList = stepProps[4].blogReviews
      .map((review, idx) => ({ review, idx }))
      .filter(({ idx }) => selectedCursors.has(idx))
      .map(({ review }) => ({
        url:        review.url ?? null,
        authorName: review.authorName,
        authorId:   review.authorId
      }));

    // 2) 필요한 authorIdList 계산 (기존 로직)
    const authorIdList = Array.from(
      new Set(
        stepProps[8].pages.flatMap(page =>
          page.captions
            .filter(cap => cap.type === 'createBy')
            .map(cap  => cap.text)
        )
      )
    );

    // 3) allAuthorInfoList에서 authorIdList에 포함된 것만 골라냄
    const usedAuthorInfoList = allAuthorInfoList.filter(info =>
      authorIdList.includes(info.authorId)
    );

    try {
        const response = await api.post(
          `/advise/admin/save-file`,
          {
            name: stepProps[8].fileName,
            region: stepProps[1],
            hotple_id: stepProps[2]=='manual' ? null : (stepProps[3].hotple ? stepProps[3].hotple.hotple_id : null),
            naver_map_place_id : stepProps[2]=='manual' ? null : (stepProps[3].hotple ? stepProps[3].hotple.naver_map_place_id : null),
            updated_device: isBrowser?'PC':(isIOS?'IOS':'ANDROID'),
            pages: JSON.stringify(stepProps[8].pages),
            contents: stepProps[8].result,
            video_preview: stepProps[8].video_preview,
            all_resource: allAuthorInfoList,
            used_resource: usedAuthorInfoList,
            addLastPromotionPage: stepProps[8].addLastPromotionPage,
            props: JSON.stringify(
              stepProps.map((item, idx) => {
                if (idx === 0) {
                  return {};
                }
                else if (idx === 3) {
                  return {...item, hotples: []};
                }
                else if (idx === 6) {
                  return {...item, blogImages: [], blogCursor: 0, officialImages:[], gifImages:{} };
                }
                else if (idx === 7) {
                    return {...item, originalImages: []};
                }
                else if (idx === 8) {
                  return {
                    ...item,
                    result: [],
                    video_preview: [],
                    oriFileName: stepProps[8].fileName,
                    file: null,
                    pages: []
                  };
                }
                return item;
              })
            )
          }
        );

        setStepProps(prev => {
            const newProps = [...prev];
            newProps[8] = {
                ...newProps[8],
                oriFileName: stepProps[8].fileName
            };
            newProps[10] = {
                ...newProps[10],
                adviseId: response.data.adviseId
            };
            return newProps;
        });

        setAdViseStep(9);
    } catch (error) {
      console.error('Error saveFiles:', error);
    } finally{
      setIsSaving(false);
    }
  }

  function checkOverPage(){
    if(files.length + (stepProps[8].addLastPromotionPage ? 1:0) > 10){
      alert('페이지 수는 최대 10장까지만 가능합니다!');
      setStepProps(prev => {
          const newProps = [...prev];
          newProps[8] = {...newProps[8], addLastPromotionPage: false}
          return newProps;
      })
    }
  }

  useEffect(()=>{
    whenNameChanged(stepProps[8].fileName || stepProps[8].oriFileName || (stepProps[3].hotple ? `${stepProps[1]}_${stepProps[3].hotple.name}` : `${stepProps[1]}_파일명`));
    checkOverPage();

    // data:video 로 시작하는 항목만
    const videoFiles = files.filter(f => f.startsWith('data:video'));

    if (videoFiles.length === 0) return;

    // 각 src의 duration을 읽어오는 헬퍼
    const loadDuration = src =>
      new Promise(resolve => {
        const vid = document.createElement('video');
        vid.preload = 'metadata';
        vid.src = src;
        vid.onloadedmetadata = () => resolve(vid.duration);
        vid.onerror         = () => resolve(0);  // 혹시 로드 실패 시 0초로 간주
      });

    // 모든 duration이 로드된 뒤에 검사
    Promise.all(videoFiles.map(loadDuration))
      .then(durations => {
        console.log(durations);
        if (durations.some(d => d < 4)) {
          alert('렌더링이 잘못된 GIF가 있습니다!\n다시 렌더링을 시도해주세요.');
          setIsPreviewMode(false);
        }
      })
      .catch(err => {
        console.warn('비디오 길이 검사 중 에러:', err);
      });
  },[])

  useEffect(()=>{
    checkOverPage();
  },[stepProps[8].addLastPromotionPage])

  useEffect(() => {
    if (!stepProps[8].fileName) {
      setFileInfoList([]);
      setIsDuplicate(false);
      return;
    }

    // 입력이 멈추고 100ms 뒤에 한 번만 호출
    const handler = setTimeout(async () => {
      try {
        const res = await api.get('/advise/admin/fileInfo', {
          params: { name: stepProps[8].fileName }
        });

        // API가 배열로 반환한다고 가정
        setFileInfoList(res.data);
        // 정확히 동일한 이름이 있는지 체크
        setIsDuplicate(
          res.data.some(item => item.name === stepProps[8].fileName)
        );
      } catch (err) {
        // 404로 내려오면 그냥 빈 리스트
        if (err.response && err.response.status === 404) {
          setFileInfoList([]);
          setIsDuplicate(false);
        } else {
          console.error('Advise fileInfo fetch error:', err);
        }
      }
    }, 200);

    return () => clearTimeout(handler);
  }, [stepProps[8].fileName]);

  return (
    <div className={styles.outerframe}>
      <div className={styles.upperframe}>
        <img
          className={styles.backbuttonIcon}
          alt="뒤로"
          src="images/back_android.svg"
          onClick={() => setIsPreviewMode(false)}
        />
        <div className={styles.titleframe}>
          <b className={styles.nextbuttontext}>콘텐츠 미리보기</b>
          <div className={styles.stepdesc}>이대로 콘텐츠 편집을 완료할까요?</div>
        </div>
        <img
          className={styles.homebuttonIcon}
          alt="홈"
          src="images/home_outlined.svg"
          onClick={whenHomeButtonClicked}
        />
      </div>

      <div
        className={styles.lowerframe}
        style={{ height: `calc(100dvh - ${marginTop}px - 103px - 74px)` }}
      >
        {files.length === 0 ? (
          <div className={styles.loadingFrame}>
            <div className={styles.loader} />
            <div className={styles.stepdesc}>편집된 결과가 없습니다.</div>
          </div>
        ) : (
            <div className={styles.contentframe}>
                <div className={styles.contiframe}>
                    <div className={styles.conticontentframe}>
                        {!isMobile &&
                          <div className={styles.pagebutton} onClick={() => sliderRef.current?.slickPrev()}>
                              <div className={styles.pagebuttontext}>◀</div>
                          </div>
                        }

                        <div className={styles.imageframe} style={{height: isMobile ? `calc(100vw / (${stepProps[8].ratio}))` : `calc(420px / (${stepProps[8].ratio}))`}}>
                            <Slider
                                ref={sliderRef}
                                {...settings}
                                className={styles.previewSlider}
                                style={{height: isMobile ? `calc(100vw / (${stepProps[8].ratio}))` : `calc(420px / (${stepProps[8].ratio}))`}}
                            >
                                {files.map((file, idx) =>
                                file.startsWith('data:video') ? (
                                    <video
                                    key={idx}
                                    src={file}
                                    autoPlay
                                    loop
                                    muted
                                    playsInline
                                    className={styles.media}
                                    />
                                ) : (
                                    <img
                                    key={idx}
                                    src={file}
                                    alt={`preview-${idx}`}
                                    className={styles.media}
                                    />
                                )
                                )}
                                {stepProps[8].addLastPromotionPage &&
                                  <img
                                    src='https://hotple.s3.ap-northeast-2.amazonaws.com/advise/last_page/instagram.jpg'
                                    className={styles.media}
                                    />
                                }
                            </Slider>

                            <div className={styles.pageframe}>
                                <div className={styles.pagetext}>{currentSlide + 1} / {stepProps[8].addLastPromotionPage ? files.length +1 : files.length}</div>
                            </div>
                        </div>

                        {!isMobile &&
                          <div className={styles.pagebutton} onClick={() => sliderRef.current?.slickNext()}>
                              <div className={styles.pagebuttontext}>▶</div>
                          </div>
                        }
                    </div>
                </div>
                <div className={styles.nameframe}>
                  <div className={styles.div0}>파일명 :</div>
                  <div className={styles.nameinput}>
                    <img className={styles.iconpen} alt="" src="images/pen.svg" />
                    <input
                          type="text"
                          id="nameInput1"
                          list="fileNameList"
                          className={isDuplicate ? styles.nameInput0 : styles.nameInput1}
                          value={stepProps[8].fileName}
                          onChange={(e) => whenNameChanged(e.target.value)}
                          placeholder={stepProps[8].oriFileName || (stepProps[3].hotple ? `${stepProps[1]}_${stepProps[3].hotple.name}` : `${stepProps[1]}_파일명`)}
                          autoComplete="off"
                          onKeyDown={(e) => {if (e.key === 'Enter') {e.target.blur();}}}
                    />
                    <datalist id="fileNameList">
                      {fileInfoList.map(item => (
                        <option key={item.id} value={item.name} />
                      ))}
                    </datalist>
                  </div>
                </div>

                <div className={styles.checkboxFrame}>
                  <div className={styles.placetitle}>마지막 홍보 페이지 추가</div>
                  <input
                    type="checkbox"
                    className={styles.checkbox}
                    checked={stepProps[8].addLastPromotionPage}
                    onChange=
                      {e => setStepProps(prev => {
                            const newProps = [...prev];
                            newProps[8] = {...newProps[8], addLastPromotionPage: e.target.checked}
                            return newProps;
                        })
                      }
                  />
                </div>
            </div>
        )}
      </div>

      <div className={styles.nextbuttonframe}>
        <div className={styles.backbutton2} onClick={()=>setIsPreviewMode(false)}>
            <div className={styles.nextbuttontext2}>다시 편집</div>
        </div>
        <div className={!stepProps[8].fileName || stepProps[8].fileName.trim().length === 0 ? styles.nextbuttonDisabled : styles.nextbutton} onClick={saveFiles}>
            <b className={styles.nextbuttontext1}>{isDuplicate ? "기존 파일 덮어쓰기 →":"저장하기 →"}</b>
        </div>
      </div>

      {isSaving &&
        <div className={styles.loadingFrame}>
          <div className={styles.loader}/>
          <div className={styles.loadingText}>
            임시 저장 중...
          </div>
        </div>
      }
    </div>
  );
};

export default FeedPreview;